/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import section4 from 'static/myshop/make/section4.png';

const Section4 = () => {
  const { mq } = useTheme();

  const section4Style = css`
    .container {
      max-width: 1535px;
      padding: 110px 40px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h2 {
        font-size: 40px;
        font-weight: 600;
        line-height: 60px;
      }
      .text {
        line-height: 28px;
        font-size: 18px;
        margin-top: 14px;
        font-weight: 200;
      }
      img {
        width: 800px;
      }
    }
    ${mq.mobile} {
      .container {
        flex-direction: column;
        padding: 0;

        .right {
          padding: 35px 32px 126px 32px;
          width: 100%;
          h2 {
            font-size: 28px;
            font-weight: 700;
            line-height: 36px;
          }
          .text {
            font-size: 14px;
            line-height: 22px;
            margin-top: 12px;
          }
        }
        img {
          width: 100%;
        }
      }
    }
  `;
  return (
    <div css={section4Style}>
      <div className="container">
        <div className="left">
          <img src={section4} alt="section3" />
        </div>
        <div className="right">
          <h2>
            친구, 가족들과
            <br />
            함께 운영해보세요
          </h2>
          <div className="text">
            내가 만든 쇼핑몰의 부운영자를 지정할 수 있습니다.
            <br />
            관심사를 공유하는 친구나, 가족들과 함께 운영해보세요.
            <br />
            서로의 지인이 많이 들어올수록 쇼핑몰의 구매도 더 많아집니다.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section4;
